export default __webpack_public_path__ + "static/media/cta-workleap.a90d68e5.png";